/**
 * @ngdoc service
 * @name checkins.factory:editContact
 *
 * @description
 *
 */



function editContact($state, $stateParams) {
    return {
        key: 'edit-contact',
        title: 'Edit',
        icon: 'pencil',
        order: 10,
        level: 'highlight',
        action(contact, vm) {
            $state.go('app.contacts.edit', {
                id: contact.id,
                contact: contact,
                store: vm.store
            })
        }
    }
}

angular
    .module('festzelt-os.contacts')
    .factory('editContact', [
        '$state',
        '$stateParams',
        editContact
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/edit-contact.js